import * as React from "react";
const SvgSurveillanceCctv = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.813 2.813v9.945h6.556v5.051H3.38l-.002-1.032-.002-1.029H1.877l-.002 2.816-.004 2.815H3.38v-2.065h7.498v-6.557h7.498V5.757l1.47-1.473 1.471-1.47h-9.252ZM4.32 4.32h13.358l-3.465 3.465-3.465 3.467H4.32V7.785Zm15.36 2.055.002 2.344.004 2.345.75.002.752.002V6.375h-.754zm-13.594.47.002.704.004.703.75.002.752.002v-1.41H6.84Zm10.78.423.001 1.992v1.992H12.88l1.992-1.992 1.994-1.992z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgSurveillanceCctv;
